import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import HomePage from '@/views/HomePage.vue'
import LoginPage from '@/views/LoginPage.vue'
import UserManagementPage from '@/views/UserManagement.vue'
import MetaManagementPage from '@/views/MetaManagement.vue'
import LicenseManagementPage from '@/views/LicenseManagement.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/home',
    name: 'Home',
    component: HomePage,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: UserManagementPage,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/meta',
    name: 'MetaManagement',
    component: MetaManagementPage,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/licenses',
    name: 'LicenseManagement',
    component: LicenseManagementPage,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  if (to.matched.some(record => record.meta.requiresAuth) && !authStore.userId) {
    next('/login')
  } else if (to.matched.some(record => record.meta.requiresAdmin) && !authStore.isAdmin) {
    // Redirect non-admin users to home page if they try to access admin-only routes
    next('/home')
  } else {
    next()
  }
})

export default router